/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { userSessionConsentsList } from "../funcs/userSessionConsentsList.js";
import { userSessionConsentsRevoke } from "../funcs/userSessionConsentsRevoke.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import {
  ListUserSessionConsentsRequest,
  ListUserSessionConsentsResponse,
  ListUserSessionConsentsSecurity,
} from "../models/operations/listusersessionconsents.js";
import {
  RevokeUserSessionConsentRequest,
  RevokeUserSessionConsentSecurity,
} from "../models/operations/revokeusersessionconsent.js";
import { unwrapAsync } from "../types/fp.js";
import { PageIterator, unwrapResultIterator } from "../types/operations.js";

export class UserSessionConsents extends ClientSDK {
  /**
   * listUserSessionConsents userSessionConsents
   *
   * @remarks
   * List consent records for the caller's project.
   */
  async list(
    request?: ListUserSessionConsentsRequest | undefined,
    security?: ListUserSessionConsentsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<
    PageIterator<ListUserSessionConsentsResponse, { cursor: string }>
  > {
    return unwrapResultIterator(userSessionConsentsList(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * revokeUserSessionConsent userSessionConsents
   *
   * @remarks
   * Withdraw consent. Subsequent authorization requests for matching (subject, user_session_client) pairs re-prompt.
   */
  async revoke(
    request: RevokeUserSessionConsentRequest,
    security?: RevokeUserSessionConsentSecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(userSessionConsentsRevoke(
      this,
      request,
      security,
      options,
    ));
  }
}
